import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import NavBar from './components/Public/NavBar';
import HomePage from './components/Public/HomePage';
import SignIn from './components/Public/SignIn';
import SignUp from './components/Public/SignUp';
import Pricing from './components/Public/Pricing'
import Dashboard from './components/User/Dashboard'
import ResetPassword from './components/Public/ResetPassword'
import NewPasswordPage from './components/Public/NewPasswordPage'
import './App.css'



class App extends Component {
  render() {
    const haveNavbar = () => (
      <Fragment>
         <NavBar />
             <Route exact path='/' component={ HomePage } />  
         <Switch>
             
             <Route path='/login' component={ SignIn } />
             <Route path='/register' component={ SignUp } />
             <Route path='/pricing' component={ Pricing } />
             <Route path='/resetpassword' component={ ResetPassword } />
             <Route path='/newpassword' component={ NewPasswordPage } />
         </Switch>
     </Fragment> 
     )
   const noNavbar = () => (
   
       <Switch>
       <Route path='/dashboard' component={ Dashboard } />
       <Route path='/allclients' component={ Dashboard } />
       <Route path='/trainers' component={ Dashboard } />
       <Route path='/test' component={ Dashboard } />
       <Route path='/account' component={ Dashboard } />
       <Route path='/scheduler' component={ Dashboard } />
       <Route path='/workout' component={ Dashboard } />
       <Route path='/nutrition' component={ Dashboard } />
       <Route path='/trainerprofile'  component={ Dashboard} />
       <Route path='/notifications'  component={ Dashboard} />
       </Switch>
    
   )
    return (
        <BrowserRouter>
        <Fragment>
           <Route exact path="/login" component={ haveNavbar }/>
           <Route exact path="/register" component={ haveNavbar }/>
           <Route exact path="/pricing" component={ haveNavbar }/>
           <Route exact path='/resetpassword' component={ haveNavbar } />
           <Route exact path='/newpassword' component={ haveNavbar } / >
           <Route exact path='/send-enquiry' component={ haveNavbar } />
           <Route exact path='/privacy' component={ haveNavbar } />
           <Route exact path='/' component={ haveNavbar } />  
           <Route component={ noNavbar }/>
        </Fragment>
      </BrowserRouter>
    );
  }
}

export default App;
